
export default (storeObj) => {
  console.log("Decorate with MockData. Nothing to do");
}
